import { apiClient } from "./apiClient";

// RCA context isteği başlatır (asenkron — MQTT round-trip)
export async function requestRca(accessToken, payload) {
  const res = await apiClient.post("/rca/request", payload, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  return res.data;
}

// Sonucu polling ile çek (status: pending/completed/failed)
export async function getRcaResult(accessToken, requestId) {
  const res = await apiClient.get(`/rca/result/${requestId}`, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  return res.data;
}
